module.exports = __webpack_public_path__ + "img/material-card3-m.e53ebc7e.png";